module.exports = __webpack_public_path__ + "static/media/12_Bild_5_ARM_Team_SoftHand-Pro_NicolaPitaro_6458.d8e65428.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle12/12_Bild_5_ARM_Team_SoftHand-Pro_NicolaPitaro_6458.jpg
 ** module id = 152
 ** module chunks = 0
 **/